var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.post)?_c('spinner',{attrs:{"large":"","center":""}}):_c('column-layout',{staticClass:"page post-page",attrs:{"sticky-sides":""},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('div',{staticClass:"card widget pa"},[_c('Post',{attrs:{"post":_vm.post}})],1)]},proxy:true}])},[void 0,void 0],2)
}
var staticRenderFns = []

export { render, staticRenderFns }